export function ChartTooltip({ active, payload, label, labelFormatter, valueFormatter, nameFormatter }: {
  active?: boolean;
  payload?: { name?: string; value?: number | string; payload?: Record<string, unknown> }[];
  label?: string;
  labelFormatter?: (label: string) => string;
  valueFormatter?: (value: number) => string;
  nameFormatter?: (name: string) => string;
}) {
  if (!active || !payload?.length) return null;
  return (
    <div className="border border-border bg-surface px-3 py-2 shadow-[0_4px_16px_rgba(0,0,0,0.12)]">
      {label ? (
        <div className="mb-1 text-[10px] font-bold uppercase tracking-[.08em] text-muted">
          {labelFormatter ? labelFormatter(label) : label}
        </div>
      ) : null}
      {payload.map((entry, i) => (
        <div key={i} className="font-mono text-sm font-semibold text-ink">
          {entry.name && !label ? (
            <span className="mr-2 font-sans text-xs font-semibold text-muted">{nameFormatter ? nameFormatter(String(entry.name)) : entry.name}</span>
          ) : null}
          {valueFormatter ? valueFormatter(Number(entry.value)) : String(entry.value)}
        </div>
      ))}
    </div>
  );
}
